import { useTranslation } from "react-i18next";
import {
  Button,
  Checkbox,
  Col,
  Form,
  message,
  Modal,
  Radio,
  Row,
  Space,
  TableColumnsType,
  TableProps,
  Typography
} from 'antd'
import React, {useEffect, useState} from 'react'
import FormInput from '../../form-input/FormInput'
import {CheckCircleOutlined, SearchOutlined} from '@ant-design/icons'
import TableData from '../../table-data/TableData'
import FormItemDropdown from '../../form-dropdown/FormItemDropdown'
import {useParams} from 'react-router-dom'
import {isEmpty} from 'lodash'
import {
  copyTemplateSequence,
  getAllSectionByCourseId,
  getListSequenceById
} from '../../../service/content-list-course/contentListCourseApi'
import {formatDate} from '../../../utils/converDate'

type Props = {
  open: boolean
  handleClose: () => void
  getListDataProps: () => void
  searchValue: string;
  filterData: any;
  tab: string
}

export default function CopyTemplateCourse(props: Props) {
  const { t } = useTranslation();
  const {open, handleClose, searchValue, tab, filterData, getListDataProps} = props
  const [sectionList, setSectionList] = useState<any>([])

  const [listData, setListData] = useState<any>([])
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [resetSelectedRowKey, setResetSelectedRowKey] = useState<boolean>(false)
  const [statusOrder, setStatusOrder] = useState<string>("")
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [searchValueSynPopup, setSearchValueSynPopup] = useState<string>('')
  const params = useParams()
  const CheckboxGroup = Checkbox.Group;
  const [form] = Form.useForm()
  const handleModalClose = () => {
    // Đặt lại giá trị tìm kiếm
    setSearchValueSynPopup('');
    // Gọi lại hàm để tải lại toàn bộ dữ liệu
    getListData();
    // Gọi hàm handleClose để đóng modal
    handleClose();
    form.resetFields();
  };

  const validations = {
    sequenceList: {
      required: true,
      message: t("Vui lòng chọn chương", "Vui lòng chọn chương"),
    },
    sequenceName: {
      required: true,
      message: t("Vui lòng nhập tên bài giảng", "Vui lòng nhập tên bài giảng"),
    },
  };

  const renderStatus = (value: string) => {
    switch (Number(value)) {
      case 0:
        return "Bản nháp"
        break;
      case 1:
        return "Riêng tư"
        break;
      case 2:
        return "Công khai"
        break;
      default:
        return "Bản nháp"
        break;
    }
  }

  const dataColumnsLesson: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      width: 10,
      render: (_: any, record, index) => {
        return <div>{record?.numericalOrder ?? 1}</div>;
      },
    },
    {
      title: t("Tên bài giảng", "Tên bài giảng"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 20,
    },
    {
      title: t("Tên chương", "Tên chương"),
      dataIndex: "sectionName",
      key: "sectionName",
      width: 20,
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "availableStatus",
      key: "availableStatus",
      width: 20,
      render: (_: any, record) => {
        return <div>{renderStatus(record?.availableStatus)}</div>;
      },
    },
    {
      title: t("Ngày xuất bản", "Ngày xuất bản"),
      dataIndex: "publishedDate",
      key: "publishedDate",
      width: 20,
      render: (_: any, record) => {
        return <>{isEmpty(record.publishedDate) ? null : formatDate(record.publishedDate ?? '')}</>;
      },
    },
    {
      title: t("Ngày bắt đầu", "Ngày bắt đầu"),
      dataIndex: "startedDate",
      key: "startedDate",
      width: 20,
      render: (_: any, record) => {
        return <>{isEmpty(record.startedDate) ? null : formatDate(record.startedDate ?? '')}</>;
      },
    },
  ]

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setStatusOrder(data);
  };

  const getDataSectionByid = async () => {
    const data = {
      courseId: Number(params?.id) ?? 0,
      type: 2,
      keyword: searchValueSynPopup.trim(),
      sectionId: tab === "1" ? null : Number(filterData.sectionId),
      sequenceId: tab === "1" || tab === '2' ? null : Number(filterData.sequenceId),
      startedDateFrom: isEmpty(filterData.planCreationDate) ? filterData.planCreationDate?.[0] : null,
      startedDateTo: isEmpty(filterData.planCreationDate) ? filterData.planCreationDate?.[0] : null,
      publishedDateFrom: isEmpty(filterData.planApprovalDate) ? filterData.planApprovalDate?.[1] : null,
      publishedDateTo: isEmpty(filterData.planApprovalDate) ? filterData.planApprovalDate?.[1] : null,
      availableStatus: filterData.availableStatus ?? null,
      sortByName: statusOrder,
      page: pageNumber,
      size: pageSize
    }
    await getListSequenceById(data).then((res: any) => {
      setListData(res.data?.body?.content)
      setTotalRecords(res.data?.body?.totalElements)
    })

  }

  const getAllSection = async () => {
    await getAllSectionByCourseId(params?.id).then((res) => {
      setSectionList(res.data)
    })
  }

  const getListData = async () => {
    getDataSectionByid()
  };

  const saveData = async (values: any) => {
    const arrIdSelectedRowkey = selectedRowKeys.map((item: any) => item.id)

    const data = {
      ids: arrIdSelectedRowkey,
      name: values.sequenceName,
      sectionId: values.sequenceList,
      description: values.description,
      status: 0
    }

    await copyTemplateSequence(data).then((res) => {
      if (res.status === 200) {
        message.success(t("Tạo bản sao bài giảng thành công", "Tạo bản sao bài giảng thành công"))
        form.resetFields()
        handleClose()
        getListDataProps()
      }
    })
  }

  useEffect(() => {
    if (!open) {
      setSearchValueSynPopup("")
      setSelectedRowKeys([])
      form.resetFields()
    }
    getListData();
    getAllSection()
    // if (!isEmpty(searchValue)) {
    //   setSearchValueSynPopup(searchValue)
    // }
  }, [open, pageNumber, statusOrder]);

  return (
    <Form.Provider onFormFinish={async (name, {values, forms}) => {
      if (name === 'copy-template-course-modal') {

        if (isEmpty(selectedRowKeys)) {
          message.error(t("Bạn chưa chọn bài giảng để tạo bản sao", "Bạn chưa chọn bài giảng để tạo bản sao"))
          return
        }

        Modal.confirm({
          title: `Xác nhận tạo bản sao bài giảng`,
          content: `Xin vui lòng xác nhận tạo bản sao bài giảng.`,
          onOk: () => {
            saveData(values);
          },
          okText: t("Xác nhận", "Xác nhận"),
          cancelText: t("Đóng", "Đóng"),
          centered: true,
          icon: <CheckCircleOutlined style={{color: "#1677FF"}}/>,
          footer: (_, {OkBtn, CancelBtn}) => (
            <>
              <CancelBtn/>
              <OkBtn/>
            </>
          ),
        });

      }
    }}>


      <Modal
        className="copy-template-content-course-modal"
        title={t("Tạo bản sao bài giảng", "Tạo bản sao bài giảng")}
        closeIcon={true}
        centered
        open={open}
        onCancel={handleModalClose}  // Gọi handleModalClose khi nhấn nút đóng
        footer={null}
        width={"80%"}
      >
        <Form
          form={form}
          name="copy-template-course-modal"
          layout="vertical"
          labelCol={{span: 8}}
          wrapperCol={{span: 14}}
        >
          <Row gutter={40} className='p-6'>
            <Col md={{span: 16}} lg={{span: 16}} xl={{span: 16}} xs={{span: 16}}>
              <Form.Item name="search">
                <FormInput
                  placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
                  value={searchValueSynPopup}
                  onChange={(e: any) => setSearchValueSynPopup(e.target?.value)}
                  onKeyPress={(e: any) => {
                    if (e.key === "Enter") {
                      getListData();
                    }
                  }}
                  // onKeyPress={(e: any) => setSearchValueSynPopup(e.target?.value)}
                  afterPrefixIcon={<SearchOutlined className='cursor-pointer' onClick={getListData}/>}
                />
              </Form.Item>

              <TableData
                dataTable={listData}
                dataColumns={dataColumnsLesson}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
                selectOneRow={true}
                pageNumber={pageNumber}
                pageSize={pageSize}
                loadingTable={loading}
                scroll={{x: 1500, y: 600}}
                totalRecords={totalRecords}
                handleTableChangeProps={handleTableChange}
                setSelectedRowKeysProps={setSelectedRowKeys}
                rowSelected={selectedRowKeys}
                pagination={true}
                hideSelection={true}
              />
            </Col>
            <Col md={{span: 8}} lg={{span: 8}} xl={{span: 8}} xs={{span: 8}}>
              <Typography.Title level={5}>{t("Thông tin bài giảng", "Thông tin bài giảng")}</Typography.Title>
              <div>
                <Form.Item name="sequenceList" label={t("Tên chương", "Tên chương")} rules={[validations.sequenceList]}>
                  <FormItemDropdown placeholder={t("Chọn chương", "Chọn chương")}
                                    options={sectionList}/>
                </Form.Item>

                <Form.Item name="sequenceName" label={t("Tên bài giảng", "Tên bài giảng")} rules={[validations.sequenceName]}
                           className='mt-2'>
                  <FormInput placeholder={t("Nhập tên bài giảng", "Nhập tên bài giảng")}/>
                </Form.Item>

                <Form.Item name="description" label={t("Mô tả", "Mô tả")} className='mt-2'>
                  <FormInput placeholder={t("Nhập mô tả", "Nhập mô tả")}/>
                </Form.Item>

                <Typography.Title level={5} className='mt-3'>{t("Trạng thái", "Trạng thái")}</Typography.Title>
                <Form.Item>
                  <Radio checked>{t("Bản nháp", "Bản nháp")}</Radio>
                </Form.Item>
                <p>{t("Phần này sẽ không được người dùng nhìn thấy", "Phần này sẽ không được người dùng nhìn thấy")}</p>
              </div>

              <div className='mt-9'>
                <Space className='float-right'>
                  <Button onClick={handleModalClose} className="btn btn-outlined">
                    <Typography.Text>
                      {t("Hủy", "Hủy")}
                    </Typography.Text>
                  </Button>
                  <Button className="btn btn-primary" onClick={() => form.submit()}
                  >
                    <Typography.Text>
                      {t("Lưu", "Lưu")}
                    </Typography.Text>
                  </Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Form.Provider>
  )
}
